import { ReactNode, ReactElement } from "react";
import { Button } from "../../components/Button";
import ReloadIcon from "../../assets/icons/reload-icon.svg";

import "./index.scss";

interface LoaderProps {
  loading: boolean;
  size?: string;
  minHeight?: string;
  overlay?: boolean;
  children?: ReactNode;
  error?: boolean;
  errorTitle?: string;
  errorSubTitle?: string;
  errorControlText?: string;
  errorControlShowIcon?: boolean;
  errorControlOnClick?: () => void;
}

export function LoaderControl({
  loading,
  children,
  minHeight,
  size,
  overlay,
  error,
  errorTitle,
  errorSubTitle,
  errorControlText,
  errorControlShowIcon,
  errorControlOnClick,
}: LoaderProps): ReactElement | null {
  const showContent = (!loading && !error) || (loading && overlay);

  const containerHeight =
    (loading || error) && !overlay ? minHeight || "300px" : "200px";

  if (loading) {
    return (
      <div
        style={{ height: containerHeight, fontSize: size }}
        className="loader-control"
      >
        <div
          data-testid="loading-indicator"
          className={`loader-container ${overlay ? "overlay" : ""}`}
        >
          <div className="loader" />
        </div>
      </div>
    );
  }

  if (!loading && error) {
    return (
      <div
        style={{ height: containerHeight, fontSize: size }}
        className="loader-control"
      >
        <div className="error-container">
          <div className="title">{errorTitle}</div>
          <div className="sub-title">{errorSubTitle}</div>

          {errorControlOnClick && (
            <div className="control">
              <Button
                outlined
                color="neutral"
                text={errorControlText || "Reload"}
                startIcon={
                  errorControlShowIcon ? (
                    <img src={ReloadIcon} alt="reveal" />
                  ) : undefined
                }
                onClick={errorControlOnClick}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  return showContent ? (children as ReactElement | null) : null;
}
